import React, { Component } from 'react';
import HidBluetoothClassic from '../../assets/images/HID-Bluetooth-Classic.png';
import CradleBluetoothClassic from '../../assets/images/Cradle-Bluetooth-Classic.png';
import AddEnterKey from '../../assets/images/Add-Enter-Key.png';
import LowVolume from '../../assets/images/Low-Volume.jpg';
import RestoreDefaults from '../../assets/images/Restore-Defaults.jpg';
// import { INVENTORY_INFO } from '../../common/config';

class InventoryInfo extends Component {
  render() {
    return (
      <div
        className="modal fade theme-modal" id="inventoryInfoModal"
        tabIndex="-1" aria-labelledby="inventoryInfoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content manage-session">
            <div className="modal-body">
              <h5 className="modal-title mt-0" id="cancelCaseModalLabel">Info</h5>
              {/* <p className="inventory-info-left new-line">{INVENTORY_INFO}</p> */}
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>P - Par Values (if entered by the office)</p>
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>C - Consigned Inventory</p>
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>S - Scanned Inventory</p>
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>V - Variance</p>
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>Scan sessions are automatically deleted from your device after 7 days.</p>
              <p className="inventory-info-left" style={{ borderBottom: '1px solid grey' }}>Consignment Inventory is typically updated once daily by the office.</p>
              <p className="inventory-info-left">Scanning can occur independent of syncing inventory.</p>
            </div>
            <div className="modal-body" style={{ borderTop: '1px solid #424242' }}>
              <p className="inventory-info-left mt-0" style={{ fontSize: '17px' }}>Zebra Scanner Barcodes</p>
              <p className="inventory-info-left">Scan the following barcode to make the Zebra scanner discoverable on Bluetooth.</p>
              <img
                src={HidBluetoothClassic}
                width="500"
                alt="icon"
              />
              <p className="inventory-info-left mt-1">Once scanning is complete, re-pair the scanner to the cradle by:</p>
              <p className="inventory-info-left">1) scanning the below barcode</p>
              <p className="inventory-info-left">2) scanning the barcode on the cradle</p>
              <img
                src={CradleBluetoothClassic}
                width="500"
                alt="icon"
              />
            </div>
            <div className="modal-body" style={{ borderTop: '1px solid #424242' }}>
              <p className="inventory-info-left mt-0" style={{ fontSize: '17px' }}>Troubleshooting Barcodes</p>
              <p className="inventory-info-left">If a Zebra scanner is not reading barcodes properly, it
                may need configured to add an Enter key after each
                scan. To add an Enter key, scan the barcode below.
              </p>
              <img
                src={AddEnterKey}
                width="500"
                alt="icon"
              />
              <p className="inventory-info-left mt-1">If issues persist, restore the scanner to default
                settings using the barcode below.
              </p>
              <p className="inventory-info-left">NOTE: Once this is done, the scanner will need
                configured to add an Enter key (see above)
              </p>
              <img
                src={RestoreDefaults}
                width="500"
                alt="icon"
              />
              <p className="inventory-info-left p-1">To lower the volume of the scanner, scan the
                barcode below.
              </p>
              <img
                src={LowVolume}
                width="500"
                alt="icon"
              />
            </div>
            <div className="modal-footer" style={{ paddingBottom: '25px' }}>
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InventoryInfo;
